import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { IconButton } from '@mui/material';
import { WsDataTable } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';

const PrivateExtensionPage = () => {
  const columns = [
    {
      Header: 'Version',
      accessor: 'version',
    },
    {
      Header: 'Updated Date',
      accessor: 'updatedDate',
    },
    {
      Header: 'Download',
      accessor: 'download',
    },
  ];
  const data = [
    {
      version: 'Automatic candidate importer Version 2.1.17 ',
      updatedDate: '01 Feb 2024',
      download: (
        <IconButton
          onClick={() => {
            window.open('https://wisestep-open.s3.amazonaws.com/extension2.1.17.zip', '_blank');
          }}
        >
          <FileDownloadOutlinedIcon color="primary" />
        </IconButton>
      ),
    },
    {
      version: 'Automatic candidate importer Version 2.1.16 ',
      updatedDate: '30 Jan 2024',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.15 ',
      updatedDate: '10 Jan 2024',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.14 ',
      updatedDate: '22 Dec 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.13 ',
      updatedDate: '08 Dec 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.12 ',
      updatedDate: '27 Nov 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.11 ',
      updatedDate: '30 OCT 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.10 ',
      updatedDate: '18 OCT 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.9 ',
      updatedDate: '03 OCT 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.8 ',
      updatedDate: '18 SEP 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.7 ',
      updatedDate: '06 JUN 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.6 ',
      updatedDate: '09 JAN 2023',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.5 ',
      updatedDate: '19 OCT 2022',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.4 ',
      updatedDate: '13 OCT 2022',
      download: '',
    },
    {
      version: 'Automatic candidate importer Version 2.1.3',
      updatedDate: '16 SEP 2022',
      download: '',
    },
  ];

  return (
    <SettingsPageLayout
      title="Private Extensions"
      indexOptions={[{ label: 'Private Extension', url: '' }]}
      goBackRequired={false}
    >
      <WsDataTable
        columns={columns}
        data={data ?? []}
        boldItems={['version', 'updatedDate']}
        dense={false}
        pageable={true}
      />
    </SettingsPageLayout>
  );
};

export default PrivateExtensionPage;
